var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }